import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NDD_75: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NDD_75,
  },
  {
    pageId: PageId.CHAT_UPSELL_NDD_75,
  },
  {
    pageId: PageId.UPSELL_NDD_75,
  },
  {
    pageId: PageId.DOWNLOAD_NDD_75,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
